import MetricsService, { EventType } from "services/MetricsService";
import BaseService from "../../services/BaseService";

const URL_BASE = process.env.REACT_APP_ENDPOINT;
export const URI_FECHAMENTO_CONSUMOS = "consumo/api/v1/fechamento";

class FechamentoConsumoService extends BaseService {
  async obtemFechamentoConsumo(filtro) {
    MetricsService.sendEvent({
      event: EventType.SOLICITA_FECHAMENTO_CONSUMO,
      extraData: filtro,
    });
    const result = await this.post(
      `${URL_BASE}${URI_FECHAMENTO_CONSUMOS}/coleta-sal`,
      filtro
    );
    return result;
  }
}

export default new FechamentoConsumoService();
